import dayjs from "dayjs";

const RUN_DATE_FORMAT = "MMM D, h:mm A";
const APPROXIMATE_RUN_DATE_FORMAT = "MMM D, [≈]h:mm A";

export const formatRunDate = (isoDate: string): string => dayjs(isoDate).format(RUN_DATE_FORMAT);

export const formatNextRunDate = (isoDate: string, frequencyInMinutes: number): string =>
    dayjs(isoDate).add(frequencyInMinutes, "minutes").format(APPROXIMATE_RUN_DATE_FORMAT);
